import { hashHistory } from 'react-router';

// Get 'app' path
import { path as APP_PATH } from '../..';

// All paths
const PATHS = {
  ROLLOUTS: 'rollouts',
  INFORMATION: 'information',
  DEVICES: 'devices',
};

// Exported paths
export const MAIN_PATH = PATHS.ROLLOUTS;
export const INFORMATION_PATH = PATHS.INFORMATION;
export const DEVICES_PATH = PATHS.DEVICES;

// Root
const APP_ROLLOUTS_PATH = `${APP_PATH}/${MAIN_PATH}`;

export const listPath = () => APP_ROLLOUTS_PATH;
export const navigateToList = () => {
  hashHistory.push(listPath());
};

export const addPath = () => `${APP_ROLLOUTS_PATH}/add`;
export const navigateToAdd = () => {
  hashHistory.push(addPath());
};

export const showPath = (id) => `${APP_ROLLOUTS_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};



// WEBPACK FOOTER //
// ./routes/app/routes/rollouts/navigation.js